import { Component, OnInit, Input, Output,EventEmitter, OnChanges, AfterViewInit, SimpleChange } from '@angular/core';
import { EvidenciasService } from 'app/_services/evidencias.service';


@Component({
  selector: 'evidenciafiltros',
  templateUrl: './evidenciafiltros.component.html',
  styleUrls: ['./evidenciafiltros.component.css']
})
export class EvidenciafiltrosComponent implements OnInit,AfterViewInit, OnChanges {

  @Input() _listaEvidencias: any; 

  @Output() onChangeValue = new EventEmitter<any>();

  listaevidencias: any=[];
  listaEvidenciasFiltro: any=[];

  listaniveldeseguridad: any;
  listamodulosevidencias: any;
  listaafectapersonalmaquinaria: any;
  listaasignacion: any;
  listanivelelemento: any;
  listanivelseguridad: any;
  listatipocomentario: any;
  listatiposancion: any;
  listaenlacesnorma: any;
  
 
  listaevidenciasfiltro: any = [];


  constructor(  private evidenciasService: EvidenciasService) { }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){

    if (changes['_listaEvidencias']){
      this.listaEvidenciasFiltro = changes['_listaEvidencias'].currentValue;
      this.listaevidencias = changes['_listaEvidencias'].currentValue;
    }
    this.listaEvidenciasFiltro.id_tipo_sancion = -1;
    this.listaEvidenciasFiltro.modoexplicito = -1;
    this.listaEvidenciasFiltro.id_asignacion = -1;
    this.listaEvidenciasFiltro.id_modev = -1;
    this.listaEvidenciasFiltro.id_persmaq = -1;
    this.listaEvidenciasFiltro.periodicidadtipo = -1;
    this.listaEvidenciasFiltro.id_nivelelemento = -1;

    this.getLista("ListagetModuloEvidencias");
    this.getLista("ListagetEvidenciaAPERMAQ");
    this.getLista("ListagetEvidenciaAsignacion");
    this.getLista("ListagetEvidenciaNivelElemento");
    this.getLista("ListagetEvidenciaNivelSeguridad");
    this.getLista("ListagetEvidenciaComentarioTipo");
    this.getLista("ListagetTipoSancion");
    
  }



  ngOnInit() {

  }

  ngAfterViewInit(){
   
  }

 

//---------------------------------------------------------------------
//-                            FILTROS
//---------------------------------------------------------------------


getLista(accion: string){
  this.evidenciasService.getLista(accion).subscribe(
    data => {
      if (data){

        let json = data.json();

        if (accion == ""){
          this.listaniveldeseguridad = json.lista;
        }
        if (accion == "ListagetModuloEvidencias"){
          this.listamodulosevidencias = json.lista;
        }
        if (accion == "ListagetEvidenciaAPERMAQ"){
          this.listaafectapersonalmaquinaria = json.lista;
        }
        if (accion == "ListagetEvidenciaAsignacion"){
          this.listaasignacion = json.lista;
        }
        if (accion == "ListagetEvidenciaNivelElemento"){
          this.listanivelelemento = json.lista;
        }
        if (accion == "ListagetEvidenciaNivelSeguridad"){
          this.listanivelseguridad = json.lista;
        }
        if (accion == "ListagetEvidenciaComentarioTipo"){
          this.listatipocomentario = json.lista;
        }
        if (accion == "ListagetTipoSancion"){
          this.listatiposancion = json.lista;
        }
      }
    }
  );
}



  filtrarLista(value,tipo){

      let auxevidencias = this.listaEvidenciasFiltro;

      this.listaevidenciasfiltro = [];

      //- Aparece en la norma de forma explícita
      if (this.listaEvidenciasFiltro.modoexplicito != -1){
        this.listaevidenciasfiltro = [];
        for (let evidencia of auxevidencias){
          
          if (evidencia.modoexplicito == this.listaEvidenciasFiltro.modoexplicito){
            this.listaevidenciasfiltro.push(evidencia);
          }
        }
      }else{
        this.listaevidenciasfiltro = auxevidencias;
      }

      auxevidencias = this.listaevidenciasfiltro;

      //- Asignación
      if (this.listaEvidenciasFiltro.id_asignacion != -1){
        this.listaevidenciasfiltro = [];
        for (let evidencia of auxevidencias){
          
          if (evidencia.id_asignacion == this.listaEvidenciasFiltro.id_asignacion){
            this.listaevidenciasfiltro.push(evidencia);
          }
        }
      }else{
        this.listaevidenciasfiltro = auxevidencias;
      }

      auxevidencias = this.listaevidenciasfiltro;
    
      //- Tipo sanción
      if (this.listaEvidenciasFiltro.id_tipo_sancion != -1){
        this.listaevidenciasfiltro = [];
        for (let evidencia of auxevidencias){
          
          if (evidencia.id_tipo_sancion == this.listaEvidenciasFiltro.id_tipo_sancion){
            this.listaevidenciasfiltro.push(evidencia);
          }
        }
      }else{
        this.listaevidenciasfiltro = auxevidencias;
      }

      auxevidencias = this.listaevidenciasfiltro;  

      //- Modulo evidencia
      if (this.listaEvidenciasFiltro.id_modev != -1){
        this.listaevidenciasfiltro = [];
        for (let evidencia of auxevidencias){
          
          if (evidencia.id_modev == this.listaEvidenciasFiltro.id_modev){
            this.listaevidenciasfiltro.push(evidencia);
          }
        }
      }else{
        this.listaevidenciasfiltro = auxevidencias;
      }

      auxevidencias = this.listaevidenciasfiltro;      

      //- Afecta personal maquinaria
      if (this.listaEvidenciasFiltro.id_persmaq != -1){
        this.listaevidenciasfiltro = [];
        for (let evidencia of auxevidencias){
          
          if (evidencia.id_persmaq == this.listaEvidenciasFiltro.id_persmaq){
            this.listaevidenciasfiltro.push(evidencia);
          }
        }
      }else{
        this.listaevidenciasfiltro = auxevidencias;
      }

      auxevidencias = this.listaevidenciasfiltro;    

      //- Periodicidad
      if (this.listaEvidenciasFiltro.periodicidadtipo != -1){
        this.listaevidenciasfiltro = [];
        for (let evidencia of auxevidencias){
          
          if (evidencia.periodicidadtipo == this.listaEvidenciasFiltro.periodicidadtipo){
            this.listaevidenciasfiltro.push(evidencia);
          }
        }
      }else{
        this.listaevidenciasfiltro = auxevidencias;
      }

      auxevidencias = this.listaevidenciasfiltro;   

      
      //- nivel elemento
      if (this.listaEvidenciasFiltro.id_nivelelemento != -1){
        this.listaevidenciasfiltro = [];
        for (let evidencia of auxevidencias){
          
          if (evidencia.id_nivelelemento == this.listaEvidenciasFiltro.id_nivelelemento){
            this.listaevidenciasfiltro.push(evidencia);
          }
        }
      }else{
        this.listaevidenciasfiltro = auxevidencias;
      }

      auxevidencias = this.listaevidenciasfiltro;   

    
      this.listaevidenciasfiltro = auxevidencias;

      this.onChangeValue.emit({value:this.listaevidenciasfiltro ,tipo:"filtrar"});
  }

   
  limpiarFiltros(){
    
    this.onChangeValue.emit({value:-1,tipo:"limpiar"});
   
  }



}



// WEBPACK FOOTER //
// ./src/app/evidenciafiltros/evidenciafiltros.component.ts